import React, { useState } from 'react';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { Button } from '@mui/material';
import { basicAuth, basicAuthMy } from '../../Api/crmPortal';
import BuyNowModal from '../popups/buyNowModal';
import CircularProgress from '@mui/material/CircularProgress';
import { Link as RouterLink } from 'react-router-dom';

const PaymentForm = ({
  userData,
  packageDetails,
  setPageDisable,
  auth,
  pageData,
  setActiveStep,
}) => {
  const [openProceedTopay, setOpenProceedToPay] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [loaderOpen, setLoader] = useState(false);

  const handleOpenTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  const handleSubmit = async (event, amt) => {
    setLoader(true);
    try {
      if (amt) {
        try {
          const formData = {
            amount: amt || packageDetails?.amount,
            productinfo: packageDetails?.productinfo,
            phone: packageDetails?.phone,
            firstName: packageDetails?.firstName,
            packageInstanceId: packageDetails?.packageInstanceId,
            couponCode: packageDetails?.couponCode,
            totalAmount: packageDetails?.amount,
            isPartPayment: !!amt,
            tenantId: packageDetails?.tenantId,
          };
          const response = await axios.post(
            `${process.env.REACT_APP_CRM_PAY_URL}/paymentgw/initpartpayment`,
            formData,
            auth
          );
          if (response?.data?.url) {
            setLoader(false);
            handleOpenTab(response?.data?.url);
            setActiveStep();
            // window.location.href = response?.data?.url;
            // window.open(response?.data?.url, '_blank');
          } else if (response?.data?.message) {
            setLoader(false);
            setOpenProceedToPay(true);
            setModalMessage(response?.data?.message);
          }
        } catch (error) {
          setLoader(false);
          console.error('Error:', error);
        }
      } else {
        try {
          const formData = {
            amount: packageDetails?.amount,
            productinfo: packageDetails?.productinfo,
            phone: packageDetails?.phone,
            firstName: packageDetails?.firstName,
            packageInstanceId: packageDetails?.packageInstanceId,
            couponCode: packageDetails?.couponCode,
            totalAmount: packageDetails?.amount,
            tenantId: packageDetails?.tenantId,
          };
          const response = await axios.post(
            `${process.env.REACT_APP_CRM_PAY_URL}/paymentgw/initpay`,
            formData,
            auth
          );
          if (response?.data) {
            // window.location.href = response?.data?.url;
            handleOpenTab(response?.data?.url);
            setActiveStep();
            // window.open(response?.data?.url, '_blank');
            // setOpenProceedToPay(true);
            setLoader(false);
          }
          // window.open(response?.data?.url, '_blank');
        } catch (error) {
          setLoader(false);
          console.error('Error:', error);
        }
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div style={{ width: '100%', opacity: loaderOpen && '0.5' }}>
      <div className="city-btn-container">
        <div className="city-btn-paynow">
          <Button
            sx={{
              width: '100%',
              height: '40px',
              backgroundColor: '#003cc4',
              borderRadius: 1,
              textTransform: 'none',
              fontFamily: 'matterMedium',
            }}
            variant="contained"
            onClick={(e) =>
              handleSubmit(e, pageData?.planDetails?.partPaymentAmount)
            }
            disabled={loaderOpen}
          >
            {pageData?.planDetails?.partialBtnText}
          </Button>
          <p
            className="mobile-hide"
            style={{
              paddingTop: '5px',
              fontFamily: 'matterThin',
              fontSize: '12px',
              textAlign: 'center',
            }}
          >
            {pageData?.planDetails?.partialBtnNote}
          </p>
        </div>
        <div className="city-btn-paynow">
          <Button
            sx={{
              width: '100%',
              height: '40px',
              // fontSize: '20px',
              // backgroundColor: '#003cc4',
              borderRadius: 1,
              textTransform: 'none',
              borderStyle: 'dashed',
              fontFamily: 'matterMedium',
            }}
            variant="outlined"
            onClick={(e) => handleSubmit(e, null)}
            disabled={loaderOpen}
          >
            {pageData?.planDetails?.fullBtnText}
          </Button>
          <p
            className="mobile-hide"
            style={{
              paddingTop: '5px',
              fontFamily: 'matterThin',
              fontSize: '12px',
              textAlign: 'center',
            }}
          >
            {pageData?.planDetails?.fullBtnNote}
          </p>
        </div>
      </div>
      {loaderOpen && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            justifyContent: 'center',
          }}
        >
          <CircularProgress />
        </div>
      )}
      <BuyNowModal
        open={openProceedTopay}
        handleClose={() => setOpenProceedToPay(false)}
        loaderOpen={loaderOpen}
        handleApprove={() => setOpenProceedToPay(false)}
        message={modalMessage}
      />
    </div>
  );
};

export default PaymentForm;
